import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import BillingInfoView from 'components/composed/views/BillingInfoView';
import ChangePasswordView from 'components/composed/views/ChangePasswordView';
import ChangeUsernameView from 'components/composed/views/ChangeUsernameView';
import ContactInfoView from 'components/composed/views/ContactInfoView';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: ${theme.spaces.smallX}px;
  width: 100%;

  > * {
    &:nth-child(1) {
      grid-row-start: 1;
      grid-row-end: 2;
    }

    &:nth-child(2) {
      grid-row-start: 2;
      grid-row-end: 3;
    }

    &:nth-child(3) {
      grid-row-start: 3;
      grid-row-end: 4;
    }

    &:last-child {
      grid-row-start: 1;
      grid-row-end: 4;
    }
  }

  @media ${theme.devices.tablet} {
    display: flex;
    flex-direction: column;
    gap: ${theme.spaces.smallX}px;
  }
`;

const AccountSettingsSection = () => {
  return (
    <StyledContainer>
      <ContactInfoView />
      <ChangeUsernameView />
      <ChangePasswordView />
      <BillingInfoView />
    </StyledContainer>
  );
};

export default AccountSettingsSection;
